import React, { lazy } from 'react';
import Suspense from '../layout/Suspense';

const LazyComponent = lazy(() => import('./ManageEmailTemplates'));

export default () => {
  return <Suspense lazyComponent={<LazyComponent />} />;
};
